import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { ConstantService } from 'src/app/services/common/constant.service';

import { UserCredentialService } from 'src/app/services/identity';
import { AuthService } from '../auth.service';

@Component({
  standalone: false,
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnInit, OnDestroy {

  public error: boolean = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    private userCredentialService: UserCredentialService,
    private constantService: ConstantService,
    private route: ActivatedRoute) { }

  async ngOnInit() {
    if (this.route.snapshot.fragment.includes('error')) {
      $("error").removeClass("error-hide");
      return this.error = true;
    }
   
    if (this.route.snapshot.queryParams['changePassword']) {
      this.authService.$isChangePassword.next(true);
      return;
    } 

    await this.authService.completeAuthentication();
    this.getUserDetail();
  }

  getUserDetail() {    
    this.authService.getUserPostLoginStatus();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
